import axios from "axios";

const BASE_URL = "https://api.bbmshop.one";

const axiosAPI = axios.create({
    baseURL: BASE_URL,
});

export default axiosAPI;